// import components
import {
  styled,
  IconButton,
  Box,
  IconButtonProps,
  Avatar,
  AvatarProps,
  alpha,
  BoxProps,
  Typography,
  TypographyProps,
  darken
} from '@mui/material';
import { NoteVariant } from '../Notes.types';
import { NOTE_VARIANT } from '../Notes.consts';

export const StyledFormattedDateBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  color: theme.palette.text.secondary,
  gap: theme.spacing(1),
  marginBottom: isCompact ? 0 : theme.spacing(0.75),
  lineHeight: isCompact ? '21px' : 'normal',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1
}));

export const StyledMaxContentIconButton = styled(IconButton)<IconButtonProps>(
  () => ({
    maxWidth: 'max-content'
  })
);
export const StyledNoteAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<AvatarProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
  width: isCompact ? '24px' : '32px',
  height: isCompact ? '24px' : '32px',
  fontSize: isCompact ? '12px' : '14px'
}));

export const StyledSingleNoteContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noteVariant' && prop !== 'isCompact'
})<BoxProps & { noteVariant?: NoteVariant; isCompact?: boolean }>(
  ({ theme, noteVariant, isCompact }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: isCompact ? theme.spacing(4, 6) : theme.spacing(7, 6),
    backgroundColor:
      noteVariant === NOTE_VARIANT.DEFAULT
        ? alpha(theme.palette.background.default, 0.75)
        : alpha(theme.palette.background.paper, 0.75),
    borderRadius: theme.shape.borderRadius,
    margin: isCompact ? theme.spacing(0, 4) : theme.spacing(2, 4),
    border: `1px solid ${darken(theme.palette.background.default, 0.03)}`,
    boxShadow:
      '0px 0px 1px rgba(84, 115, 110, 0.01),0px 1px 5px rgba(84, 115, 110, 0.02),0px 2px 12px rgba(84, 115, 110, 0.04)'
  })
);

export const StyledNoMessagesContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: isCompact ? theme.spacing(2, 4) : theme.spacing(8, 6),
  backgroundColor: isCompact
    ? theme.vars.palette.surface.dim
    : theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  marginTop: isCompact ? 0 : theme.spacing(2)
}));

export const StyledNoMessagesTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<TypographyProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  fontSize: isCompact ? '12px' : '16px',
  color: theme.palette.text.secondary,
  textAlign: 'center'
}));
